import { Modal, ModalBody } from "reactstrap";

import step1Img1Src from '~/assets/images/presentation/mobile/step1-img-1.svg';
import step1Img2Src from '~/assets/images/presentation/mobile/step1-img-2.svg';
import step1Img3Src from '~/assets/images/presentation/mobile/step1-img-3.svg';

import step2Img1Src from '~/assets/images/presentation/mobile/step2-img-1.svg';
import step2Img2Src from '~/assets/images/presentation/mobile/step2-img-2.svg';
import step2Img3Src from '~/assets/images/presentation/mobile/step2-img-3.svg';

import step3Img1Src from '~/assets/images/presentation/mobile/step3-img-1.svg';
import step3Img2Src from '~/assets/images/presentation/mobile/step3-img-2.svg';
import step3Img3Src from '~/assets/images/presentation/mobile/step3-img-3.svg';

import step4Img1Src from '~/assets/images/presentation/mobile/step4-img-1.svg';
import CustomSlider, { type PresentationSlideColumn } from "../CustomSlider";
import { TPresentationModalProps } from ".";

const items: PresentationSlideColumn[] = [
  {
    src: step1Img1Src,
    text: "To get started, click the secure link sent to you by text and email.",
  },
  {
    src: step1Img2Src,
    text: `<p>There is a quick self-guided verification process that may include:</p>
      <ul>
        <li>Uploading a photo of your Driver’s License or Passport</li>
        <li>Taking a quick selfie</li>
        <li>Providing insurance or a secondary ID if requested</li>
      </ul>`,
  },
  {
    src: step1Img3Src,
    text: "Simply select “Continue” after each step. Please keep your browser open until you see the message “ID Verification Successful.”",
  },
  {
    src: step2Img1Src,
    text: "Once your verification steps are complete, the dealership will securely send your documents to a local Mavsign notary.",
  },
  {
    src: step2Img2Src,
    text: "Once the notary receives your documents, they will contact you to schedule your signing appointment. You will also confirm this appointment when prompted.",
  },
  {
    src: step2Img3Src,
    text: "Follow your order link at any time to chat with us by using the CONTACT US button, top right.",
  },
  {
    src: step3Img1Src,
    text: `<p>Witnessing the signing of your documents</p>
    <p>Verifying your identity, in-person, by collecting:</p>
    <ul>
      <li>A photo of your ID</li>
      <li>Your thumbprint on an Affidavit of Identity</li>
    </ul>`,
  },
  {
    src: step3Img2Src,
    text: "Collecting any requested items such as downpayment, additional verification documents, etc.",
  },
  {
    src: step3Img3Src,
    text: `<p>Verifying your identity, in-person, by collecting:</p>
    <ul>
      <li>A photo of your ID</li>
      <li>Your thumbprint on an Affidavit of Identity</li>
    </ul>`,
  },
  {
    src: step4Img1Src,
    text: "Collecting any requested items such as downpayment, additional verification documents, etc.",
  },
];

const MobilePresentationModal = ({ open, onToggle }: TPresentationModalProps) => {

  return (
    <Modal
      className="presentation-modal"
      isOpen={open}
      toggle={onToggle}
      centered
      fade={false}
    >
      <ModalBody>
        <h1 className="custom-title">{`What's Next?`}</h1>
        <p className="custom-description">{`You're just a few quick steps away from completing your signing. Here's what to expect:`}</p>
        <CustomSlider items={items} />
      </ModalBody>
      <button type="button" className="btn btn-primary m-auto my-2 d-block w-100 mt-5" aria-label="Close" onClick={onToggle}>Start process</button>
    </Modal>
  );
}

export default MobilePresentationModal;